import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';

type Variables = {
  id: number;
  amount: number;
};

export type CreateJooserIntent = {
  data: {
    stripeSecret?: string;
    ephemeralKey?: string;
    customerSessionSecret?: string;
    stripeCustomerId?: string;
  };
};

export const useCreateJooserIntent = createMutation<
  CreateJooserIntent,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: `v2/reservations/${variables.id}/jooser/intent`,
      method: 'POST',
      data: { amount: variables.amount },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
